import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import Spinner from "components/spinner/Spinner";
import { selectCurrentUser } from "features/user/userSlice";
import React, { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import "styles/main.scss";

export default function Main() {
  // const currentUser = useSelector((state) => state.user.currentUser);
  const currentUser = useSelector(selectCurrentUser);

  const Homepage = lazy(() => import("pages/homepage/Homepage"));
  const Shop = lazy(() => import("pages/shop/Shop"));
  const ShopCategories = lazy(() =>
    import("pages/shopCategories/ShopCategories")
  );
  const ProductDetail = lazy(() => import("pages/productDetail/ProductDetail"));
  const Checkout = lazy(() => import("pages/checkout/Checkout"));
  const Signin = lazy(() => import("pages/signin/Signin"));
  const Signup = lazy(() => import("pages/signup/Signup"));
  const NotFound = lazy(() => import("pages/notFound/404"));

  return (
    <Suspense fallback={<Spinner />}>
      <div className="Main 2xs:py-0 xl:px-0 xl:py-0 flex flex-col min-h-screen justify-between">
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:shopCategory" element={<ShopCategories />} />
          <Route
            path="/shop/:shopCategory/:productId"
            element={<ProductDetail />}
          />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/signin" element={<Signin />} />
          <Route
            path="/signup"
            element={currentUser ? <Signin /> : <Signup />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Suspense>
  );
}
